import theme from '@styles/theme';
export default {
  pagePropsSizeWrapper: {
    display: 'flex',
    flexFlow: 'row wrap',
    paddingTop: '15px',
    paddingLeft: '10px'
  },
  singlePageProp: {
    width: '100%'
  },
  singlePagePropName: {
    cursor: 'pointer'
  },
  singlePagePropNameTip: {
    fontSize: theme.fontSizes.omnibus
  },
  singlePropBarWrapper: {
    width: '100%'
  },
  singlePagePropBar: {
    cursor: 'pointer',
    position: 'relative',
    height: '25px',
    width: '50%',
    maxWidth: '300px',
    background: '#e5e7e9',
    borderRadius: '0 15px 15px 0'
  },
  singlePagePropStart: {
    position: 'absolute',
    left: '-10px',
    top: 0,
    height: '25px',
    width: '25px',
    background: 'transaprent',
    zIndex: theme.zIndex.documentUp
  },
  singlePagePropStartDot: {
    width: '100%',
    height: '100%',
    borderRadius: '15px',
    background: 'green',
    border: '6px solid #0d0d14'
  },
  singlePagePropBarFill: (procent: number) => ({
    width: `${procent}%`,
    background: 'green',
    height: '100%',
    borderRadius: '0 15px 15px 0'
  }),
  singlePagePropBarText: {
    position: 'absolute',
    top: 0,
    left: 'calc(50% - 10px)',
    textAlign: 'center',
    color: 'black',
    height: '100%',
    fontSize: '14px',
    fontWeight: '600',
    paddingTop: '2px'
  }
};